/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import moment from 'moment';
import 'moment/locale/de';

export enum TimestampFormat {
	DD_MM_YYYY_AT_HH_MM_O_CLOCK = 'DD.MM.YYYY [um] HH:mm [Uhr]',
	DD_MM_YYYY_HH_MM = 'DD.MM.YYYY HH:mm',
	DD_MM_YY_HH_MM = 'DD.MM.YY, HH:mm',
	DD_MM_YYYY = 'DD.MM.YYYY',
	DD_MM_YY = 'DD.MM.YY',
	DD_MMMM = 'DD.MMM'
}

export class TimeService {
	parseTimestamp(timestamp: number, format: TimestampFormat): string {
		return moment(timestamp).format(format);
	}

	parseTimestampDE(timestamp: number, format: TimestampFormat): string {
		return moment(timestamp).locale('de').format(format);
	}
}
